export var CUSTOM_PAGE_STATE_NAME = 'index.customercare.customer.customPage';
export function routing($stateProvider) {
  $stateProvider.state(CUSTOM_PAGE_STATE_NAME, {
    url: '/customPage/:pageId',
    template: '<custom-page-contextual></custom-page-contextual>'
  });
}